var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { attrs: { "md-flex": "90", "md-flex-offset": "5" } },
        [
          _c(
            "md-card",
            { staticClass: "md-table-card content-table" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "header-row" }, [
                  _c("h2", { staticClass: "md-title" }, [
                    _vm._v("Reporting Dashboard")
                  ]),
                  _c(
                    "div",
                    { staticClass: "header-right" },
                    [
                      _c(
                        "div",
                        { staticClass: "period-control" },
                        [
                          _c("span", { staticClass: "period-label-text" }, [
                            _vm._v("Period:")
                          ]),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              attrs: {
                                disabled: _vm.loading || _vm.generating
                              },
                              on: { click: _vm.prevPeriod }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-chevron-left" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "md-menu",
                            {
                              attrs: {
                                "md-direction": "bottom-end",
                                "md-size": "auto"
                              }
                            },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-icon-button",
                                  attrs: {
                                    "md-menu-trigger": "md-menu-trigger"
                                  }
                                },
                                [
                                  _c("md-icon", {
                                    attrs: {
                                      "md-iconset": "fa fa-calendar-alt"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("md-menu-content", [
                                _c(
                                  "div",
                                  { staticClass: "period-picker-popup" },
                                  [
                                    _c(
                                      "md-input-container",
                                      [
                                        _c("label", [_vm._v("Month")]),
                                        _c(
                                          "md-select",
                                          {
                                            on: {
                                              selected: _vm.onPeriodChanged
                                            },
                                            model: {
                                              value: _vm.filters.month,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "month",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.month"
                                            }
                                          },
                                          _vm._l(_vm.months, function(m) {
                                            return _c(
                                              "md-option",
                                              {
                                                key: m.value,
                                                attrs: { value: m.value }
                                              },
                                              [_vm._v(_vm._s(m.name))]
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "md-input-container",
                                      [
                                        _c("label", [_vm._v("Year")]),
                                        _c(
                                          "md-select",
                                          {
                                            on: {
                                              selected: _vm.onPeriodChanged
                                            },
                                            model: {
                                              value: _vm.filters.year,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "year",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.year"
                                            }
                                          },
                                          _vm._l(_vm.years, function(y) {
                                            return _c(
                                              "md-option",
                                              {
                                                key: y.value,
                                                attrs: { value: y.value }
                                              },
                                              [_vm._v(_vm._s(y.value))]
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          ),
                          _c("span", { staticClass: "current-period-label" }, [
                            _vm._v(_vm._s(_vm.currentPeriodLabel))
                          ]),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              attrs: {
                                disabled: _vm.loading || _vm.generating
                              },
                              on: { click: _vm.nextPeriod }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-chevron-right" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.isSuperAdmin()
                        ? _c(
                            "md-button",
                            {
                              staticClass: "md-raised md-primary",
                              attrs: {
                                disabled: _vm.generating || !_vm.canSearch
                              },
                              on: { click: _vm.generateReport }
                            },
                            [
                              _c("md-icon", {
                                staticClass: "on-left",
                                attrs: { "md-iconset": "fa fa-sync-alt" }
                              }),
                              _vm._v(
                                _vm._s(
                                  _vm.generating
                                    ? "Generating..."
                                    : "Generate / Regenerate"
                                )
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "role-tabs" }, [
                _c(
                  "button",
                  {
                    staticClass: "role-tab",
                    class: { active: _vm.activeRole === "content-owner" },
                    on: {
                      click: function($event) {
                        return _vm.setRole("content-owner")
                      }
                    }
                  },
                  [_vm._v("CONTENT OWNER")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "role-tab",
                    class: { active: _vm.activeRole === "buyer" },
                    on: {
                      click: function($event) {
                        return _vm.setRole("buyer")
                      }
                    }
                  },
                  [_vm._v("BUYER")]
                )
              ]),
              _c(
                "stitch-loader",
                { attrs: { loading: _vm.loading, size: 45 } },
                [
                  _vm.report && _vm.isContentOwnerRole
                    ? _c("div", [
                        _c("div", { staticClass: "summary-row" }, [
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("LICENSING GROSS REVENUE")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(_vm.summary.licensingGross)
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("RHEBUS COMMISSION - LICENSING")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.summary.rhebusCommission
                                  )
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("LICENSING NET REVENUE")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(_vm.summary.netEarnings)
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("RENTAL NET REVENUE")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.rentalTotals.netEarnings
                                  )
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("TOTAL NET REVENUE")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.summary.totalWithRentals
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.isBuyerRole
                    ? _c("div", [
                        _c("div", { staticClass: "summary-row" }, [
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("TOTAL LICENSING COST")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.buyerSummary.totalLicensingCost
                                  )
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("TOTAL PLAYS")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.buyerSummary.totalPlays.toLocaleString()
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("VIDEOS LICENSED")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.buyerSummary.videosLicensed.toLocaleString()
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "summary-card" }, [
                            _c("div", { staticClass: "summary-label" }, [
                              _vm._v("AVERAGE CPM")
                            ]),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.buyerSummary.averageCpm
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.isContentOwnerRole && !_vm.report && !_vm.loading
                    ? _c("md-layout", { attrs: { "md-align": "center" } }, [
                        _c(
                          "div",
                          { staticClass: "no-data" },
                          [
                            _c("md-icon", {
                              staticClass: "md-accent",
                              attrs: {
                                "md-iconset": "fa fa-exclamation-circle"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                "No report found for the selected period. Use the Generate button to create one."
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "licensing-search-filter-row" },
                [
                  _c(
                    "md-input-container",
                    { staticClass: "search-input-container" },
                    [
                      _c("md-input", {
                        attrs: { placeholder: "Search by video name..." },
                        model: {
                          value: _vm.licensingSearchText,
                          callback: function($$v) {
                            _vm.licensingSearchText = $$v
                          },
                          expression: "licensingSearchText"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isContentOwnerRole && _vm.licenseeOptions.length > 0
                    ? _c(
                        "div",
                        { staticClass: "licensee-filter" },
                        [
                          _c("span", { staticClass: "licensee-label" }, [
                            _vm._v("Licensee:")
                          ]),
                          _c(
                            "md-input-container",
                            [
                              _c(
                                "md-select",
                                {
                                  on: { selected: _vm.applyLicenseeFilter },
                                  model: {
                                    value: _vm.filters.licenseeAccountId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filters,
                                        "licenseeAccountId",
                                        $$v
                                      )
                                    },
                                    expression: "filters.licenseeAccountId"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "" } }, [
                                    _vm._v("All Licensees")
                                  ]),
                                  _vm._l(_vm.licenseeOptions, function(l) {
                                    return _c(
                                      "md-option",
                                      { key: l.id, attrs: { value: l.id } },
                                      [_vm._v(_vm._s(l.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isContentOwnerRole && _vm.distributionOptions.length > 0
                    ? _c(
                        "div",
                        { staticClass: "licensee-filter" },
                        [
                          _c("span", { staticClass: "licensee-label" }, [
                            _vm._v("Distribution:")
                          ]),
                          _c(
                            "md-input-container",
                            [
                              _c(
                                "md-select",
                                {
                                  on: { selected: _vm.applyLicenseeFilter },
                                  model: {
                                    value: _vm.filters.distribution,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "distribution", $$v)
                                    },
                                    expression: "filters.distribution"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "" } }, [
                                    _vm._v("All Distributions")
                                  ]),
                                  _vm._l(_vm.distributionOptions, function(d) {
                                    return _c(
                                      "md-option",
                                      { key: d.id, attrs: { value: d.id } },
                                      [_vm._v(_vm._s(d.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isBuyerRole && _vm.buyerContentOwners.length > 0
                    ? _c(
                        "div",
                        { staticClass: "licensee-filter" },
                        [
                          _c("span", { staticClass: "licensee-label" }, [
                            _vm._v("Content Owner:")
                          ]),
                          _c(
                            "md-input-container",
                            [
                              _c(
                                "md-select",
                                {
                                  on: { selected: _vm.applyBuyerFilters },
                                  model: {
                                    value: _vm.filters.contentOwner,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "contentOwner", $$v)
                                    },
                                    expression: "filters.contentOwner"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "" } }, [
                                    _vm._v("All Content Owners")
                                  ]),
                                  _vm._l(_vm.buyerContentOwners, function(
                                    owner
                                  ) {
                                    return _c(
                                      "md-option",
                                      { key: owner, attrs: { value: owner } },
                                      [_vm._v(_vm._s(owner))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isBuyerRole && _vm.buyerDistributions.length > 0
                    ? _c(
                        "div",
                        { staticClass: "licensee-filter" },
                        [
                          _c("span", { staticClass: "licensee-label" }, [
                            _vm._v("Distribution:")
                          ]),
                          _c(
                            "md-input-container",
                            [
                              _c(
                                "md-select",
                                {
                                  on: { selected: _vm.applyBuyerFilters },
                                  model: {
                                    value: _vm.filters.distribution,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "distribution", $$v)
                                    },
                                    expression: "filters.distribution"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "" } }, [
                                    _vm._v("All Distributions")
                                  ]),
                                  _vm._l(_vm.buyerDistributions, function(
                                    dist
                                  ) {
                                    return _c(
                                      "md-option",
                                      {
                                        key: dist.id,
                                        attrs: { value: dist.id }
                                      },
                                      [_vm._v(_vm._s(dist.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("h3", { staticClass: "section-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.isBuyerRole
                      ? "Licensed Content Costs"
                      : "Licensing Revenue"
                  )
                )
              ]),
              _c(
                "stitch-loader",
                { attrs: { loading: _vm.loadingLicensed, size: 45 } },
                [
                  _vm.activeRows.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "table",
                          class: { "buyer-table": _vm.isBuyerRole }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "titleLine styleRow" },
                            _vm._l(_vm.activeColumns, function(col) {
                              return _c(
                                "p",
                                {
                                  key: col.label,
                                  staticClass: "rowElements",
                                  class: { sortable: !!col.sortKey },
                                  on: {
                                    click: function($event) {
                                      return _vm.onColumnHeaderClick(col)
                                    }
                                  }
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(col.label))]),
                                  col.sortKey
                                    ? _c("md-icon", {
                                        attrs: {
                                          "md-iconset": _vm.sortIconFor(
                                            col.sortKey
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._l(_vm.activeRows, function(item, idx) {
                            return _c(
                              "div",
                              {
                                key: item._id || item.mediaItemId || idx,
                                staticClass: "styleRow colorHover"
                              },
                              _vm._l(_vm.activeColumns, function(col) {
                                return _c(
                                  "div",
                                  {
                                    key: col.label,
                                    staticClass: "rowElements"
                                  },
                                  [_vm._v(_vm._s(col.getValue(item)))]
                                )
                              }),
                              0
                            )
                          }),
                          _vm.isContentOwnerRole
                            ? _c(
                                "div",
                                { staticClass: "styleRow totals-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "rowElements",
                                      staticStyle: { "font-weight": "600" }
                                    },
                                    [_vm._v("Totals")]
                                  ),
                                  _c("div", { staticClass: "rowElements" }),
                                  _c("div", { staticClass: "rowElements" }),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.licensingTotals.plays.toLocaleString()
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayCurrency(
                                          _vm.licensingTotals.gross
                                        )
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayCurrency(
                                          _vm.licensingTotals.rhebusCommission
                                        )
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayCurrency(
                                          _vm.licensingTotals.net
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm.isBuyerRole
                            ? _c(
                                "div",
                                { staticClass: "styleRow totals-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "rowElements",
                                      staticStyle: { "font-weight": "600" }
                                    },
                                    [_vm._v("Totals")]
                                  ),
                                  _c("div", { staticClass: "rowElements" }),
                                  _c("div", { staticClass: "rowElements" }),
                                  _c("div", { staticClass: "rowElements" }),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.buyerTotals.totalPlays.toLocaleString()
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "rowElements totals-accent"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatCurrency(
                                            _vm.buyerTotals.totalCost
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c("md-table-pagination", {
                            attrs: {
                              "md-size": _vm.currentLicensingPagination.size,
                              "md-total": _vm.isContentOwnerRole
                                ? _vm.totalLicensedMediaItems
                                : _vm.totalBuyerRows,
                              "md-page": _vm.currentLicensingPagination.page,
                              "md-label": "Rows",
                              "md-separator": "of",
                              "md-page-options": [10, 25, 50, 100]
                            },
                            on: { pagination: _vm.onLicensingPageChanged }
                          })
                        ],
                        2
                      )
                    : !_vm.loadingLicensed
                    ? _c(
                        "div",
                        { staticClass: "no-data" },
                        [
                          _c("md-icon", {
                            staticClass: "md-accent",
                            attrs: { "md-iconset": "fa fa-info-circle" }
                          }),
                          _c("span", [
                            _vm._v("No licensing data for selected filters")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm.isBuyerRole
                ? _c("div", { staticClass: "billing-information" }, [
                    _c("div", { staticClass: "billing-information__title" }, [
                      _vm._v("Billing Information")
                    ]),
                    _c("div", { staticClass: "billing-information__text" }, [
                      _vm._v(
                        "These are the costs for videos you've licensed from other creators. The cost is calculated based on the number of plays (impressions) your audience generates, divided by 1,000 and multiplied by the CPM (cost per thousand impressions) listed. Each video may appear in multiple distributions (channels), and costs are calculated separately per distribution."
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.report && _vm.isContentOwnerRole
                ? _c("div", [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v("Rental Revenue")
                    ]),
                    _vm.rentalRows.length > 0 ||
                    _vm.rentalPagination.totalCount > 0
                      ? _c(
                          "div",
                          { staticClass: "table" },
                          [
                            _c("div", { staticClass: "titleLine styleRow" }, [
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("DATE")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("VIDEO NAME")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("PRICE")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("SOURCE")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("PLATFORM FEE")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("RHEBUS COMMISSION")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("NET EARNINGS")
                              ])
                            ]),
                            _vm._l(_vm.rentalRows, function(row, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass: "styleRow colorHover"
                                },
                                [
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(_vm._s(_vm.formatDate(row.date)))
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(row.name || row.videoName || "—")
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(_vm.formatCurrency(row.price))
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(_vm._s(row.source || "—"))
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCurrency(row.platformFee)
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCurrency(row.rhebusCommission)
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "rowElements" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCurrency(row.netEarnings)
                                      )
                                    )
                                  ])
                                ]
                              )
                            }),
                            _c("div", { staticClass: "styleRow totals-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "rowElements",
                                  staticStyle: { "font-weight": "600" }
                                },
                                [_vm._v("Totals")]
                              ),
                              _c("div", { staticClass: "rowElements" }),
                              _c("div", { staticClass: "rowElements" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatCurrency(_vm.rentalTotals.price)
                                  )
                                )
                              ]),
                              _c("div", { staticClass: "rowElements" }),
                              _c("div", { staticClass: "rowElements" }, [
                                _vm._v(
                                  "-" +
                                    _vm._s(
                                      _vm.formatCurrency(
                                        _vm.rentalTotals.platformFee
                                      )
                                    )
                                )
                              ]),
                              _c("div", { staticClass: "rowElements" }, [
                                _vm._v(
                                  "-" +
                                    _vm._s(
                                      _vm.formatCurrency(
                                        _vm.rentalTotals.rhebusCommission
                                      )
                                    )
                                )
                              ]),
                              _c("div", { staticClass: "rowElements" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatCurrency(
                                      _vm.rentalTotals.netEarnings
                                    )
                                  )
                                )
                              ])
                            ]),
                            _c("md-table-pagination", {
                              attrs: {
                                "md-size": _vm.currentRentalPagination.size,
                                "md-total": _vm.rentalPagination.totalCount,
                                "md-page": _vm.currentRentalPagination.page,
                                "md-label": "Rows",
                                "md-separator": "of",
                                "md-page-options": [10, 25, 50, 100]
                              },
                              on: { pagination: _vm.onRentalPageChanged }
                            })
                          ],
                          2
                        )
                      : !_vm.loadingLicensed
                      ? _c(
                          "div",
                          { staticClass: "no-data" },
                          [
                            _c("md-icon", {
                              staticClass: "md-accent",
                              attrs: { "md-iconset": "fa fa-info-circle" }
                            }),
                            _c("span", [
                              _vm._v("No rental data for selected filters")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-976f7b46", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-976f7b46","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/report/LicensingReportTable.vue
// module id = 1026
// module chunks = 0